import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { NOTIFICATION_TAP } from '../../constants'
import type { NOTIFICATION_TAP_TYPE } from '../../constants'

import { StoresContext } from '../../provider/StoreProvider'

import { Head } from '../../components/head/Head'
import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { Header } from '../../components/header'
import { Tab } from '../../components/tab'
import { MainNotice } from './MainNotice'
import { MainNotification } from './MainNotification'

const HEAD_INFO = {
  title: '공지 및 알림 | 미술품 조각투자 플랫폼, 아티피오',
  ogTitle: '공지 및 알림 | 미술품 조각투자 플랫폼, 아티피오',
  ogUrl: window.location.href,
}

export function Notify() {
  const {
    commonStore: { setShowTab },
  } = useContext(StoresContext)

  const [listType, setListType] = useState<NOTIFICATION_TAP_TYPE>(NOTIFICATION_TAP.NOTICE)

  useEffect(() => {
    setShowTab(false)
  }, [])

  const onSegmentChange = (value: NOTIFICATION_TAP_TYPE) => setListType(value)

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="공지/알림" />
        <Tab<NOTIFICATION_TAP_TYPE>
          items={[
            { text: '공지', value: 'NOTICE' },
            { text: '알림', value: 'NOTIFICATION' },
          ]}
          onChange={onSegmentChange}
        />
        <StyledContent id="infinity-scroll-target">
          {listType === NOTIFICATION_TAP.NOTICE && <MainNotice />}
          {listType === NOTIFICATION_TAP.NOTIFICATION && <MainNotification />}
        </StyledContent>
      </Wrap>
    </>
  )
}

const StyledContent = styled(Content)`
  padding-top: 16px;
`
